import {
  Lightbulb,
  Drop,
  ThermometerHot,
  Broom,
  WarningDiamond,
  Package,
  Key,
  Elevator,
  Garage,
  Question,
  Briefcase,
  Users,
  IdentificationBadge,
} from "@phosphor-icons/react";

export const BUILDING = {
  name: "Résidence Les Tilleuls",
  address: "24 rue des Acacias, 67100 Strasbourg",
  features: { cleaning: true },
};

export const CATEGORIES = [
  { key: "eclairage", label: "Ampoule / Éclairage", Icon: Lightbulb },
  { key: "fuite", label: "Fuite / Plomberie", Icon: Drop },
  { key: "chauffage", label: "Chauffage / Chaudière", Icon: ThermometerHot },
  { key: "proprete", label: "Propreté / Ordures", Icon: Broom },
  { key: "degradation", label: "Dégradation / Choc", Icon: WarningDiamond },
  { key: "encombrants", label: "Encombrants / Déménagement", Icon: Package },
  { key: "serrurerie", label: "Serrurerie / Accès", Icon: Key },
  { key: "ascenseur", label: "Ascenseur", Icon: Elevator },
  { key: "porte_garage", label: "Porte de garage", Icon: Garage },
  { key: "autre", label: "Autre demande", Icon: Question },
];

export const categoryByKey = (k) => CATEGORIES.find((c) => c.key === k) || CATEGORIES[6];

export const LOCATIONS = [
  "Hall d'entrée",
  "Escalier",
  "Couloir / Palier",
  "Ascenseur",
  "Cour extérieure",
  "Parking",
  "Local poubelles",
  "Cave",
  "Autre",
];

export const STATUSES = {
  nouveau: { label: "Nouveau", bg: "#E5F0FF", text: "#004EEB" },
  en_cours: { label: "En cours", bg: "#FFF0D4", text: "#B25E02" },
  resolu: { label: "Résolu", bg: "#E2F6ED", text: "#007A4D" },
  rejete: { label: "Rejeté", bg: "#FFE5E5", text: "#C90A0A" },
};

export function formatDate(iso) {
  return new Intl.DateTimeFormat("fr-FR", { day: "numeric", month: "long", year: "numeric" }).format(new Date(iso));
}

export function formatDateShort(iso) {
  return new Intl.DateTimeFormat("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric" }).format(new Date(iso));
}

export function formatDay(iso) {
  return new Intl.DateTimeFormat("fr-FR", { weekday: "short", day: "numeric", month: "long" }).format(new Date(iso));
}

export function formatTime(iso) {
  return new Intl.DateTimeFormat("fr-FR", { hour: "2-digit", minute: "2-digit" }).format(new Date(iso));
}

export const CONTACT_ROLES = [
  { key: "gestionnaire", label: "Gestionnaire de copropriété", Icon: Briefcase },
  { key: "concierge", label: "Concierge", Icon: IdentificationBadge },
  { key: "conseil", label: "Conseil syndical", Icon: Users },
];

export const roleByKey = (k) => CONTACT_ROLES.find((r) => r.key === k) || CONTACT_ROLES[2];

export const DOC_CATEGORIES = [
  { key: "pv_ag", label: "PV d'assemblée générale" },
  { key: "reglement", label: "Règlement de copropriété" },
  { key: "contrat", label: "Contrat / Devis" },
  { key: "autre", label: "Autre document" },
];

export const docCategoryLabel = (k) => (DOC_CATEGORIES.find((d) => d.key === k) || DOC_CATEGORIES[3]).label;

export const ACCESS_PERMISSIONS = [
  { key: "reports", label: "Signalements" },
  { key: "visits", label: "Entretien" },
  { key: "annuaire", label: "Prestataires" },
  { key: "contacts", label: "Contacts" },
  { key: "documents", label: "Documents" },
];

export const permLabel = (k) => (ACCESS_PERMISSIONS.find((p) => p.key === k) || {}).label || k;

export const ACCOUNT_ROLES = [
  { key: "concierge", label: "Concierge" },
  { key: "agent_entretien", label: "Agent d'entretien" },
  { key: "conseil", label: "Conseil syndical" },
];

export const accountRoleLabel = (k) => (ACCOUNT_ROLES.find((r) => r.key === k) || {}).label || k;
